import { createSelector } from '@ngrx/store';
import { IRootState } from '../../../root';
import { IPrivacyState } from './privacy.state';

export class PrivacySelectors {
  // todo: replace any type state with root state (once defined)
  static readonly privacyState = (state: IRootState): IPrivacyState => {
    return state.privacy as IPrivacyState;
  };

  static readonly model = createSelector(PrivacySelectors.privacyState, (privacy: IPrivacyState) => {
    return privacy.model;
  });

  static readonly data = createSelector(PrivacySelectors.privacyState, (privacy: IPrivacyState) => {
    return privacy.data;
  });
}
